import type { TDatadogErrorLog } from 'utils/datadog/types'

export const RENAME_NICHES_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/rename-niches-form/index.ts',
  name: 'Renames niches',
  message: 'Renames a list of niches',
}
